import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import { Typography } from "../../index";
import './dropdown.scss';

export const DropDownMenu = ({
    id,
    onClick = () => { },
    onKeyDown = () => { },
    options,
    required = false,
    selectedId,
    selectedIndex
}) => {

    return (<ul
            id={`${id}-list`}
            className="bsw-dropdown-menu bsw-dropdown__options"
            role="listbox"
            aria-activedescendant={selectedId}
            aria-labelledby={id}
            tabIndex="-1"
        >
        {!required &&
            <li
                id={`${id}-option-0`}
                role="option"
                tabIndex="0"
                className={`bsw-dropdown__option-item`}
                onClick={(e) => onClick(e, '', '', '')}
                onKeyDown={(e) => onKeyDown(e, '', '', '')}
            >
                <Typography type="body-02" color="$color-secondary-a2">Please select</Typography>
            </li>
        }
        {options && options.map((opt, index) => {
            const optionIndex = required ? index.toString() : (index + 1).toString();
            return (
                <li
                    id={`${id}-option-${optionIndex}`}
                    role="option"
                    aria-selected={optionIndex === selectedIndex}
                    tabIndex="0"
                    className={`bsw-dropdown__option-item ${optionIndex === selectedIndex ? 'bsw-dropdown__option-item--active' : ''}`}
                    key={index}
                    onClick={(e) => onClick(e, opt.value, opt.label, optionIndex)}
                    onKeyDown={(e) => onKeyDown(e, opt.value, opt.label, optionIndex)}
                >
                    <Typography type="body-02" color="$color-secondary-a2">{opt.label}</Typography>
                </li>
            )
        })
        }
    </ul>)
}

DropDownMenu.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    selectedId: PropTypes.string,
    selectedIndex: PropTypes.string,
    value: PropTypes.string,
}